module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAABVElEQVRIx2P4c1FsQBDDqMWjFqOj6nRBDydNDVWJ3FhxJ0s+QQEeFQWJBH9+Glr867zY0/2SXZWGkypFowNEitOi46Nc3a0Fm9KFm4qMgFK/L9DMxz31Ho1uwtmpota2XAlR3sXZ3st6BJ3teOs9xSa1+tAwqD+elKjy5jC2smqqy8pLMSxI1q8pS5DVFavyYv94QpyGFgNDe002R7S+X2Nr+dT5ix2rNkUW92hruAIFgVKkWcxgMZkkdKKR1UmlqLw5s6KpMCY1LiTGX98g9kQTK6nmkG5xC6uWbkVdYopVsJeli1llfKq0Q9XxFtpbvDKQrTtP1VJTxkBNyUBD2V5XdGU97+ogNtpaLGlTEqhqv86Wc54Nj6+dZLSv7FJ77tW2XM7qbjK2RTS0mMuiScy2FsQ2bpMVdZSW8GUw7QVyhWzqeSwaSLP4nKDagKBRi4e/xQA67Dl4S3nBogAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/ec.png
// module id = 272
// module chunks = 0